/**
 * Journey Object fields (current/cumulative data) use Liferay Rich Text, which is sanitized
 * with AntiSamy (~200KB max per field). Snapshots must not include full BI API payloads or
 * client-only prefetch caches.
 */

function cloneJson(value) {
  if (value == null) return value;
  try {
    return JSON.parse(JSON.stringify(value));
  } catch {
    return null;
  }
}

function parseObject(value) {
  if (!value) return null;
  if (typeof value === "object" && !Array.isArray(value)) return value;
  if (typeof value === "string") {
    try {
      const parsed = JSON.parse(value);
      return parsed && typeof parsed === "object" && !Array.isArray(parsed)
        ? parsed
        : null;
    } catch {
      return null;
    }
  }
  return null;
}

function firstPresent(...values) {
  return values.find((value) => value != null && value !== "");
}

function buildSlimBiResult(biResult) {
  const bi = parseObject(biResult);
  if (!bi) return biResult;

  const nestedResponse = parseObject(bi.response);
  const ivs = Array.isArray(bi.InputValidationStatus)
    ? bi.InputValidationStatus
    : nestedResponse && Array.isArray(nestedResponse.InputValidationStatus)
      ? nestedResponse.InputValidationStatus
      : null;
  const pdf = firstPresent(
    bi.PDFURL,
    bi.pdfUrl,
    bi.pdfURL,
    nestedResponse?.PDFURL,
    nestedResponse?.pdfUrl,
    nestedResponse?.pdfURL,
  );

  const slim = {};
  if (pdf) {
    slim.PDFURL = pdf;
    slim.pdfUrl = pdf;
    slim.pdfURL = pdf;
  }
  if (Array.isArray(ivs) && ivs.length > 0) {
    slim.InputValidationStatus = ivs.map((item) => ({
      ModalPremium: item.ModalPremium ?? item.modalPremium,
      modalPremium: item.modalPremium ?? item.ModalPremium,
      PPT: item.PPT ?? item.ppt,
      ppt: item.ppt ?? item.PPT,
      PT: item.PT ?? item.pt,
      pt: item.pt ?? item.PT,
    }));
  }
  return slim;
}

/**
 * Reduces Redux journey snapshot size before submitLead / journey PATCH.
 * @param {object|null|undefined} snapshot
 * @returns {object|null|undefined}
 */
export function slimJourneyReduxSnapshotForPersistence(snapshot) {
  const copy = cloneJson(snapshot);
  if (!copy || typeof copy !== "object") {
    return copy;
  }

  if (copy.quoteResult && typeof copy.quoteResult === "object") {
    const qr = { ...copy.quoteResult };
    if (qr.biResult != null) {
      qr.biResult = buildSlimBiResult(qr.biResult);
    }
    copy.quoteResult = qr;
  }

  delete copy.multiDimensionByPlan;
  delete copy.multiDimensionPremiumResult;

  return copy;
}
